export default "__VITE_ASSET__BHHav1bm__"